/** @type {Styles} */

export const styles = {
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingY: 2,
    paddingX: 3,
    backgroundColor: (theme) => theme.palette.custom.user.header,
  },
  content: { paddingY: 3, paddingX: 3 },
  title: {
    typography: 'header4',
    color: (theme) => theme.palette.gray[80],
    lineHeight: 1.4,
  },
  actionConfig: {
    py: 0,
  },
}
